import { InjectionToken } from '@angular/core';
import { LogEvent, LogSink } from './log-event';

/**
 * Default production/server sink — a NO-OP (zero console output), satisfying
 * "no console in production". Override LOG_SINK to forward events to a remote
 * collector, BroadcastChannel, etc.
 */
export class NoopLogSink implements LogSink {
  write(_event: LogEvent): void {
    /* intentionally empty */
  }
}

/** DI token for the active log sink (defaults to a no-op). */
export const LOG_SINK = new InjectionToken<LogSink>('LOG_SINK', {
  providedIn: 'root',
  factory: () => new NoopLogSink(),
});
